import { PlayerContentType as EvgenPlayerContentType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import type { PlayerBaseInfoContent } from '@/scenarios/legacy-player/components/player-manager/context/PlayerBaseInfoProvider';
import type { Dependencies } from '@/scenarios/legacy-player/hooks/analytics/use-dependencies';

type PlayerArgEvgenArgs = {
    channelId?: string;
    contentType: EvgenPlayerContentType;
    filmId: string;
};

const apolloContentTypeToEvgenContentType = {
    Film: EvgenPlayerContentType.Film,
    Episode: EvgenPlayerContentType.Episode,
    Video: EvgenPlayerContentType.Film,
    TvChannel: EvgenPlayerContentType.TvChannel,
    OttTrailer: EvgenPlayerContentType.Trailer,
    SportBroadcast: EvgenPlayerContentType.LiveTranslation,
};

function isRecongisedContentType(
    contentType: string | undefined
): contentType is keyof typeof apolloContentTypeToEvgenContentType {
    if (!contentType) {
        return false;
    }
    return Object.keys(apolloContentTypeToEvgenContentType).includes(contentType);
}

/** Evgen-параметры из `content` ответа PlayerBaseInfo и `contentId` запроса. */
export function buildPlayerArgsFromPlayerBaseInfoContent(
    data: PlayerBaseInfoContent,
    contentId: string
): PlayerArgEvgenArgs {
    let channelId: string | undefined;

    if (data?.__typename === 'TvChannel') {
        channelId = data.channelContentId;
    }

    let filmId = contentId;

    if (data?.__typename === 'Episode' && data.tvSeries?.contentId) {
        filmId = data.tvSeries.contentId;
    }

    const contentType = isRecongisedContentType(data?.__typename)
        ? apolloContentTypeToEvgenContentType[data.__typename]
        : EvgenPlayerContentType.Film;

    return {
        channelId,
        contentType,
        filmId,
    };
}

export const readPlayerArgs: (
    dependencies: Pick<Dependencies, 'getPlayerBaseInfo'>,
    props: {
        contentId: string;
    }
) => PlayerArgEvgenArgs = (dependencies, { contentId }) => {
    const baseInfo = dependencies.getPlayerBaseInfo();

    return buildPlayerArgsFromPlayerBaseInfoContent(baseInfo?.content ?? null, contentId);
};
